import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BizCard from '../../components/UI/BizCard';

import LcsFis from './LcsFis';

import { textareaToHtml } from '../../utils/globals';

class LeadConversionSheet extends Component {
  render() {
    const { lcsFis, lcs } = this.props;
    const {
      companyName,
      termsAgreed,
      termsOfNegotiation,
      justification,
      expectedOtherBusiness,
    } = lcs;

    return (
      <div>
        {
          lcsFis ?
            <LcsFis lcsFis={lcsFis} />
            :
            null
        }
        <BizCard title="Lead Conversion Sheet">
          <table className="biz-form-table">
            <tbody>
              {/* Company Name */}
              <tr>
                <td className="biz-form-table-label">Company Name</td>
                <td className="biz-form-table-input">{companyName}</td>
              </tr>

              {/* Terms Agreed */}
              <tr>
                <td className="biz-form-table-label">Terms Agreed</td>
                <td className="biz-form-table-input">{textareaToHtml(termsAgreed)}</td>
              </tr>

              {/* Terms Negotiation */}
              <tr>
                <td className="biz-form-table-label">If No, terms of negotiation</td>
                <td className="biz-form-table-input">{textareaToHtml(termsOfNegotiation)}</td>
              </tr>

              {/* Justification */}
              <tr>
                <td className="biz-form-table-label">Justification</td>
                <td className="biz-form-table-input">{textareaToHtml(justification)}</td>
              </tr>

              {/* Expected Other Business */}
              <tr>
                <td className="biz-form-table-label">Expected Other Business</td>
                <td className="biz-form-table-input">{textareaToHtml(expectedOtherBusiness)}</td>
              </tr>
            </tbody>
          </table>
        </BizCard>
      </div>
    );
  }æ
}

LeadConversionSheet.propTypes = {
  lcsFis: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  lcs: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

LeadConversionSheet.defaultProps = {
  lcsFis: null,
};

export default LeadConversionSheet;



// WEBPACK FOOTER //
// ./src/pages/leads/LeadConversionSheet.jsx